import { render, staticRenderFns } from "./ManipulationMenuPro.vue?vue&type=template&id=69604fa4&scoped=true"
import script from "./ManipulationMenuPro.vue?vue&type=script&lang=js"
export * from "./ManipulationMenuPro.vue?vue&type=script&lang=js"
import style0 from "./ManipulationMenuPro.vue?vue&type=style&index=0&id=69604fa4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69604fa4",
  null
  
)

export default component.exports